function refreshCounters() {
    // nov 26th 2021 the below code was fixed. However this code was no longer required.
    return;
    
    var i = 0;
    var chances = 4;
    var intervalTimer = 1000;
    var interval = setInterval(function () {
        i++;
        var hasLoaded = Object.keys(__sharethis__.load_counts_cache).length != 0;
        if (hasLoaded) {
            doRefreshCounters();
            clearInterval(interval);
        } else if (i > chances) {
            clearInterval(interval);
        }
    }, intervalTimer);

    function doRefreshCounters() {
        var $ = jQuery;
        var counters = __sharethis__.load_counts_cache;

        $.each(counters, function (index, counter) {
            var c = counter;

            var total = 0;
            if (c.response && c.response.total) {
                total = c.response.total.value || 0;
            }
            var i = "\"" + JSON.stringify(index).substr(8);
            
            var t = {
                "data": JSON.parse(i)
            };
            
            var h = t.data.split("/").slice(-2).join("/");

            // look for read more button to match data with button
            var e = $('a.read-story-button[href*="' + h + '"]').closest('.read-more, .read-more-brighter');
            if (!e.length) {
                // just find the first share button on page
                e = $('.social-share');
            }

            // find the social share spacer DOM element
            var s = e;
            if (!e.find('.social-share-spacer').length) {
                s = e.siblings('div:has(".social-share-spacer")');
            }

            // insert text
            var text = s.find(".social-share-spacer");
            if (total != 1) {
                $(text).text(total + " SHARES");
            } else {
                $(text).text(total + " SHARE");
            }

            // special case if url match current page
            if (window.location.href == t.data) {
                var text = total != 1 ? "SHARES" : "SHARE";
                $("#article-shares").text(total + " " + text);
            }
        });
    }
}
